export const isVersionsTabEnabledForShare = ({
  isPublicShare,
  includeOriginalFile,
  versionCount,
  canViewPrivateTabs,
  canDownloadAssets,
}: {
  isPublicShare: boolean;
  includeOriginalFile?: boolean;
  versionCount: number;
  canViewPrivateTabs: boolean;
  canDownloadAssets: boolean;
}) => (isPublicShare ? includeOriginalFile && versionCount > 0 && canDownloadAssets : canViewPrivateTabs);
